import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-modal-ver-errores',
  templateUrl: './modal-ver-errores.component.html',
  styleUrls: ['./modal-ver-errores.component.scss'],
})
export class ModalVerErroresComponent implements OnInit {
  @ViewChild('verErrores', { static: true }) verErroresModal: ModalDirective;

  // Utils
  private log: any;

  listaErrores: any[];
  listaErroresAll: any[];
  paginationContext: PaginationContext = new PaginationContext();

  // Callbacks
  private closeCallback: Function;

  constructor(private clog: ConsoleService) {
    this.log = this.clog.log('VER-RESULTADO');
  }

  ngOnInit() {
    this.paginationContext.RecordsByPage = 10;
  }

  loadAndShow(data: any[], closeCallback: Function = null) {
    this.cleanUp();
    this.log('loadAndShow', data);

    this.closeCallback = closeCallback;

    this.paginationContext.RecordsCount = data.length; //totalRegistros
    this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
    this.paginationContext.CurrentPage = 1; // paginaActual
    this.listaErroresAll = data;
    this.showPage(1);

    this.verErroresModal.show();
  }

  show() {
    this.verErroresModal.show();
  }

  cleanUp() {
    this.listaErroresAll = null;
    this.listaErrores = null;
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaErrores = _.slice(this.listaErroresAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  closeModal() {
    if (this.closeCallback) this.closeCallback();
    this.verErroresModal.hide();
  }
}
